import { ref } from 'vue';
import { defineStore } from 'pinia';

interface AiSettings {
    enabled: boolean,
    toolsAi: {
        providerType: string,
        tools: {
            textGenerator: {
                seoMetadata: {
                    enabled: boolean,
                    model: string
                },
                dynamicForm: {
                    enabled: boolean,
                    model: string
                },
                searchResultsHighlight: {
                    enabled: boolean,
                    model: string
                },
            },
            imageGenerator: {
                createImages: {
                    enabled: boolean,
                    model: string
                }
            },
            vision: {
                descriptImage: {
                    enabled: boolean,
                    model: string
                }
            }
        },
        openAi: {
            pricing: {
                unit: boolean,
                models: {
                    gpt4VisionPreviewInput: string,
                    gpt4VisionPreviewOutput: string,
                    dalle3StandardSquare1024: string,
                    dalle3StandardRectangle1792: string,
                    dalle3HdSquare1024: string,
                    dalle3HdRectangle1792: string,
                    gpt4oInput: string,
                    gpt4oOutput: string,
                    gpt4oMiniInput: string,
                    gpt4oMiniOutput: string
                }
            }
        },
        azureOpenAi: {
            pricing: {
                unit: boolean,
                models: {
                    gpt4VisionPreviewInput: string,
                    gpt4VisionPreviewOutput: string,
                    dalle3StandardSquare1024: string,
                    dalle3StandardRectangle1792: string,
                    dalle3HdSquare1024: string,
                    dalle3HdRectangle1792: string,
                    gpt4oInput: string,
                    gpt4oOutput: string,
                    gpt4oMiniInput: string,
                    gpt4oMiniOutput: string
                }
            }
        }
    },
    assistantAi: {
        providerType: string,
        openAi: {
            pricing: {
                unit: boolean,
                models: {
                    gpt4Input: string,
                    gpt4Output: string,
                    gpt4oInput: string,
                    gpt4oOutput: string,
                    gpt4oMiniInput: string,
                    gpt4oMiniOutput: string
                }
            }
        },
        azureOpenAi: {
            pricing: {
                unit: false,
                models: {
                    gpt4Input: string,
                    gpt4Output: string,
                    gpt4oInput: string,
                    gpt4oOutput: string,
                    gpt4oMiniInput: string,
                    gpt4oMiniOutput: string
                }
            }
        }
    }
}

export const useAiSettingsStore = defineStore('aiSettings', () =>
{
    const aiSettings = ref<AiSettings>({
        enabled: true,
        toolsAi: {
            providerType: "",
            tools: {
                textGenerator: {
                    seoMetadata: {
                        enabled: false,
                        model: ""
                    },
                    dynamicForm: {
                        enabled: false,
                        model: ""
                    },
                    searchResultsHighlight: {
                        enabled: false,
                        model: ""
                    },
                },
                imageGenerator: {
                    createImages: {
                        enabled: false,
                        model: ""
                    }
                },
                vision: {
                    descriptImage: {
                        enabled: false,
                        model: ""
                    }
                }
            },
            openAi: {
                pricing: {
                    unit: false,
                    models: {
                        gpt4VisionPreviewInput: "",
                        gpt4VisionPreviewOutput: "",
                        dalle3StandardSquare1024: "",
                        dalle3StandardRectangle1792: "",
                        dalle3HdSquare1024: "",
                        dalle3HdRectangle1792: "",
                        gpt4oInput: "",
                        gpt4oOutput: "",
                        gpt4oMiniInput: "",
                        gpt4oMiniOutput: ""
                    }
                }
            },
            azureOpenAi: {
                pricing: {
                    unit: false,
                    models: {
                        gpt4VisionPreviewInput: "",
                        gpt4VisionPreviewOutput: "",
                        dalle3StandardSquare1024: "",
                        dalle3StandardRectangle1792: "",
                        dalle3HdSquare1024: "",
                        dalle3HdRectangle1792: "",
                        gpt4oInput: "",
                        gpt4oOutput: "",
                        gpt4oMiniInput: "",
                        gpt4oMiniOutput: ""
                    }
                }
            }
        },
        assistantAi: {
            providerType: "",
            openAi: {
                pricing: {
                    unit: false,
                    models: {
                        gpt4Input: "",
                        gpt4Output: "",
                        gpt4oInput: "",
                        gpt4oOutput: "",
                        gpt4oMiniInput: "",
                        gpt4oMiniOutput: ""
                    }
                }
            },
            azureOpenAi: {
                pricing: {
                    unit: false,
                    models: {
                        gpt4Input: "",
                        gpt4Output: "",
                        gpt4oInput: "",
                        gpt4oOutput: "",
                        gpt4oMiniInput: "",
                        gpt4oMiniOutput: ""
                    }
                }
            }
        }
    });

    return { aiSettings };
});
